import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Cameras/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/Cameras/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/Cameras/GetById`, payload),
    Add: (payload) => Repository.post(`/api/Cameras/Add`, payload),
    Edit: (payload) => Repository.post(`/api/Cameras/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/Cameras/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/Cameras/ChangeStatus`, payload),
}